export function modifyObj(obj, path, value) {
    const [key, ...rest] = path;
    if (!key) return obj;
    if (rest.length === 0) {
        return { ...obj, [key]: value };
    }
    return {
        ...obj,
        [key]: modifyObj(obj[key] || {}, rest, value),
    };
}

export function isDev() {
    const hostname = window.location.hostname;
    return hostname === "localhost" || hostname.includes("dev");
}

export function cleanWordpressHTML(obj) {
    if (typeof obj === "string") {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = obj;
        return textarea.value;
    }

    if (Array.isArray(obj)) {
        return obj.map(cleanWordpressHTML);
    }

    if (typeof obj === "object" && obj !== null) {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                key,
                cleanWordpressHTML(value),
            ])
        );
    }

    return obj;
}

export function toTitleCase(text) {
    return text.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}
